import { useHttpClientDispatchable } from "../../../common/modules/httpClient/hooks/useHttpClientDispatchable";
import { RequestMethodEnum } from "../../../common/modules/httpClient/enums/RequestMethodEnum";
import { IconTypeEnum } from "../../../entities/columns/orgIconLibrary/IconTypeEnum";

export const useIconLibraryLinkService = (props: { iconType: IconTypeEnum }) =>
  useHttpClientDispatchable({
    url: `/iconLibrary/${props.iconType}`,
    method: RequestMethodEnum.POST,
  });
